<template>
   <v-container fluid class="px-10" style="height:100vh">
      <v-row class="pt-3">
         <v-toolbar dense color="primary white--text" bottom>
            <v-toolbar-title v-if="$vuetify.breakpoint.mdAndUp">
               Application Settings
            </v-toolbar-title>
            <v-toolbar-title v-else>
               <v-icon color="white">mdi-hammer-wrench</v-icon>
               Settings
            </v-toolbar-title>
         </v-toolbar>
      </v-row>
      <v-row class="full-height">
         <v-col cols="12" md="3" class="px-1">
            <v-card outlined flat height="80vh" class="scroll">
               <v-list>
                  <v-list-item-group active-class="menuselect">
                     <v-list-item
                        v-for="(menu, i) in usermenu"
                        :key="i"
                        @click="GoSettingApp(menu)"
                     >
                        <v-list-item-icon>
                           <v-icon v-text="menu.icon"></v-icon>
                        </v-list-item-icon>
                        <v-list-item-content>
                           <v-list-item-title v-text="menu.text"></v-list-item-title>
                        </v-list-item-content>
                     </v-list-item>
                  </v-list-item-group>
               </v-list>
            </v-card>
         </v-col>
         <v-col cols="12" md="9" class="px-1">
            <v-card outlined flat height="80vh" v-if="$vuetify.breakpoint.mdAndUp">
               <v-sheet>
                  <component :is="settingapp"></component>
               </v-sheet>
            </v-card>
         </v-col>
      </v-row>
   </v-container>
</template>

<script>
   import TermYearSetting from "@/components/TermYearSetting.vue";
   import CCAScheduleSetting from "@/components/CCAScheduleSetting.vue";
   import CCADefaultSetting from "@/components/CCADefaultSetting.vue";
   import PublicHolidaySetting from "@/components/PublicHolidaySetting.vue";
   import CCAProposalSetting from "@/components/CCAProposalSetting.vue";
   import DefaultMessageSetting from "@/components/DefaultMessageSetting.vue";

   export default {
      data() {
         return {
            setting_menu: [
               {
                  icon: "mdi-domain",
                  text: "Term/Year",
                  route: "/TermYearSetting",
                  component: TermYearSetting,
               },
               {
                  icon: "mdi-calendar",
                  text: "Schedule",
                  route: "/CCAScheduleSetting",
                  component: CCAScheduleSetting,
               },
               {
                  icon: "mdi-ballot",
                  text: "CCA Defaults",
                  route: "/CCADefaultSetting",
                  component: CCADefaultSetting,
               },
               {
                  icon: "mdi-format-list-checkbox",
                  text: "CCA Proposal",
                  route: "/CCAProposalSetting",
                  component: CCAProposalSetting,
               },
               {
                  icon: "mdi-calendar",
                  text: "Public Holiday",
                  route: "/PublicHolidaySetting",
                  component: PublicHolidaySetting,
               },
               {
                  icon: "mdi-email-edit-outline",
                  text: "Default Messages",
                  route: "/DefaultMessageSetting",
                  component: DefaultMessageSetting,
               },
            ],
            settingapp: null,
            usermenu: [],
         };
      },
      methods: {
         GoSettingApp(menuitem) {
            this.$globalstore.user.lastsettingapp = menuitem.component;

            if (this.$vuetify.breakpoint.mobile) {
               this.$router.push(menuitem.route);
            } else {
               this.settingapp = menuitem.component;
            }
         },

         buildSettingMenu() {
            // TODO: Check user cap for each menu item
            this.usermenu = this.setting_menu;
         },
      },
      mounted() {
         this.buildSettingMenu();
         // console.log(
         //    "Appsetting mounted lastapp",
         //    this.$globalstore.user.lastsettingapp
         // );
         if (this.$globalstore.user.lastsettingapp && !this.$vuetify.breakpoint.mobile) {
            let menuitem = this.setting_menu.find(
               (x) => x.component === this.$globalstore.user.lastsettingapp
            );
            if (menuitem) {
               // console.log(menuitem);
               this.GoSettingApp(menuitem);
            }
         }
      },
   };
</script>

<style scoped>
   .scroll {
      overflow-y: scroll;
   }

   .menuselect {
      background: #e57373 !important;
      color: white !important;
   }
</style>
